"use client";

import { createContext } from "react";

export const TranslationContext = createContext(null);

export default function TranslationProvider({ children, dictionary }) {
  return <TranslationContext.Provider value={dictionary}>{children}</TranslationContext.Provider>;
}
